/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountBlock } from './AccountBlock';
import {
    AccountBlockFromJSON,
    AccountBlockFromJSONTyped,
    AccountBlockToJSON,
} from './AccountBlock';

/**
 * 
 * @export
 * @interface AccountBlockedOutput
 */
export interface AccountBlockedOutput {
    /**
     * 
     * @type {AccountBlock}
     * @memberof AccountBlockedOutput
     */
    account?: AccountBlock;
    /**
     * 
     * @type {Error}
     * @memberof AccountBlockedOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the AccountBlockedOutput interface.
 */
export function instanceOfAccountBlockedOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountBlockedOutputFromJSON(json: any): AccountBlockedOutput {
    return AccountBlockedOutputFromJSONTyped(json, false);
}

export function AccountBlockedOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountBlockedOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': !exists(json, 'account') ? undefined : AccountBlockFromJSON(json['account']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AccountBlockedOutputToJSON(value?: AccountBlockedOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': AccountBlockToJSON(value.account),
        'error': value.error,
    };
}

